import { useMutation } from '@apollo/client';

import { STAFF_CANCEL_TRANSACTION } from '../graphql/mutations/staffCancelTransactionMutation.graphql';

interface CancelTransactionVariables {
  transactionId?: string;
  userId?: string;
  eventId?: string;
}

export const useStaffCancelTransactionMutation = () => {
  const [mutate] = useMutation(STAFF_CANCEL_TRANSACTION);

  const cancelTransaction = ({
    transactionId,
    userId,
    eventId,
  }: CancelTransactionVariables) => {
    mutate({
      variables: {
        transactionId,
        userId,
        eventId,
      },
    });
  };

  return { cancelTransaction };
};
